import { FC, memo } from 'react';
import { AppAutocomplete } from '../../../../common/components/AppAutocomplete/AppAutocomplete';
import { AppAutocompleteComponentProps } from '../../../../common/interfaces';
import { useAutocompleteHostingsQuery } from '../../queries';
import { parseSelectData } from '../../../../common/utils';

interface Props extends AppAutocompleteComponentProps {}

export const HostingsAllAutocomplete: FC<Props> = memo((props) => {
  return (
    <AppAutocomplete
      { ...props }
      options={
        (data) =>
          parseSelectData(data, {
            value: 'id',
            label: 'name'
          })
      }
      notFoundDescription="Немає хостингів"
      placeholder="Знайдіть хостинг"
      query={ useAutocompleteHostingsQuery }
    />
  );
});
